const checkEmptyFieldValue = (value) => {
  const isEmpty = (val) => val === '' || val === null || val === undefined || Number.isNaN(val);

  if (Array.isArray(value)) {
    return value.some(obj =>
      (obj.hasOwnProperty('phone') && isEmpty(obj.phone)) ||
      (obj.hasOwnProperty('email') && isEmpty(obj.email))
    );
  }
  
  return isEmpty(value);
}

export default checkEmptyFieldValue;